
const Month = (props: any) : JSX.Element => {
  return (
    <div>Month</div>
  )
}
 

export default Month